module.exports = __webpack_public_path__ + "img/game-icon.a298d601.png";